import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { orderBy } from '../services/mapping.service';

@Pipe({
  name: 'orderData'
})
export class OrderDataPipe implements PipeTransform {

  transform(args: any[],field:any,type:any="asc"): any {
    return orderBy(args,field,type)
  }

}

@Pipe({
  name: 'dateOnly'
})
export class DateOnlyPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value) return;
    return moment(value).format('DD MMM, YYYY');
  }

}
